import useBootstrapData from '@/hooks/useBootstrapData'

export default function useTravelChatBot() {
  const { locale } = useBootstrapData()
  return locale?.countryCode?.toLowerCase() === 'us'
}
